export interface AppointmentOutcomePaymentDetails {
    id?: string | null;
    paymentStatusId: string | null;
    value: number | null;
    signingDate: string | Date | null;
    isDirectDebitFormCompleted: boolean;
    numberOfPayments: number | null;
    version?: number | null;
}

export function createAppointmentOutcomePaymentDetails(): AppointmentOutcomePaymentDetails {
    return {
        paymentStatusId: null,
        value: null,
        signingDate: null,
        isDirectDebitFormCompleted: false,
        numberOfPayments: null,
    };
}
